import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  defaultOpen = false
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-slate-200 rounded-lg overflow-hidden" data-id="element-308">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-slate-50 transition-colors text-left" data-id="element-309">
        <span className="font-semibold text-slate-900" data-id="element-310">{title}</span>
        <ChevronDownIcon className={`w-5 h-5 text-slate-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-311" />
      </button>
      {isOpen && <div className="px-6 py-4 bg-slate-50 border-t border-slate-200" data-id="element-312">
          {children}
        </div>}
    </div>;
}